export const orders = {
  title: 'Orders',
  orders: 'Orders',
  resourceName: 'Order',
  orderManagement: 'Order Management',
  searchCode: {
    label: 'Search by order number or tracking number',
    placeholder: 'Enter order number or tracking number',
  },
  filter: {
    placeholder: 'Search orders',
    advancedFilter: 'Advanced filter',
    code: 'Order code',
    name: 'Order name',
    subCustomerCode: 'Sub customer code',
    subCustomerPlaceholder: 'Sub customer code',
    numberOfPack: 'Packages',
    customer: 'Customer',
    fromWarehouse: 'From warehouse',
    toWarehouse: 'To warehouse',
    createdAtFrom: 'Created from',
    createdAtTo: 'Created to',
    clearFilter: 'Clear filter',
    search: 'Search',
  },
  fields: {
    id: 'ID',
    code: 'Code',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    status: 'Status',
    customerId: 'Customer ID',
    customerName: 'Customer name',
    customerCode: 'Customer code',
    orderCode: 'Order code',
    ladingCode: 'Lading code',
    customer: 'Customer',
    shipments: 'Shipments',
    totalPack: 'Total packages',
    totalVolume: 'Total volume (m³)',
    totalWeight: 'Total weight (kg)',
    totalNumberOfPack: 'Total number of packages',
    fee: 'Fee (CN¥)',
    orderCreate: 'Order created',
    notes: 'Notes',
    actions: 'Actions',
    domesticShippingFee: 'Domestic shipping fee',
    towingFee: 'Towing fee',
    otherFee: 'Other fee',
    createdBy: 'Created by',
    isUnofficialWay: 'Unofficial way',
  },
  form: {
    ladingCode: {
      label: 'Lading code',
      helperText: 'Enter the lading code for the order',
      validate: 'Please enter the lading code',
    },
    notes: {
      label: 'Customer notes',
      helperText: 'Enter customer notes for the order',
      validate: 'Please enter customer notes for the order',
    },
    totalNumberOfPack: {
      label: 'Total number of packages',
      helperText: 'Enter the total number of packages for the order',
      validate: 'Please enter the total number of packages',
    },
    domesticShippingFee: {
      label: 'Domestic shipping fee',
      helperText: 'Enter the domestic shipping fee for the order',
      validate: 'Please enter the domestic shipping fee',
    },
    towingFee: {
      label: 'Towing fee',
      helperText: 'Enter the towing fee for the order (if applicable)',
      validate: 'Please enter the towing fee',
    },
    otherFee: {
      label: 'Other fee',
      helperText: 'Enter any other fees for the order (if applicable)',
      validate: 'Please enter any other fees',
    },
    isUnofficialWay: {
      label: 'Unofficial way',
      helperText:
        'All shipments of this order will not be calculated through the system and will always be in the destination warehouse',
      validate: 'Please enter the unofficial way',
    },
    sectionOrderInfo: 'Order information',
    sectionFee: 'Fees (CNY)',
    placeholderLadingCode: 'Enter lading code',
    placeholderNotesOptional: 'Notes (optional)',
    labelShippingFee: 'Shipping fee',
    checkboxUnofficialWay: 'Unofficial route',
  },
  detail: {
    tabShipments: 'Shipments',
    tabInfo: 'General info',
    tabPrice: 'Price',
    noImages: 'No images',
    shipmentsListTitle: 'Shipments list',
    addShipment: 'Add shipment',
    duplicateShipment: 'Duplicate',
    editShipment: 'Edit shipment',
    noShipments: 'No shipments',
    totalShipments: 'Total: {total} shipments',
    price: {
      columnStt: 'No.',
      columnInfo: 'Info',
      columnPacks: 'Packs',
      columnPriceByWeight: 'Price by weight',
      columnPriceByVolume: 'Price by volume',
      columnFinalPrice: 'Final price',
      pricePerKg: 'Price/kg',
      pricePerM3: 'Price/m³',
      priceByWeight: 'Price by weight',
      priceByVolume: 'Price by volume',
      totalShipments: 'Total shipments:',
      domesticShippingFee: 'Domestic shipping fee:',
      towingFee: 'Towing fee:',
      otherFee: 'Other fee:',
      total: 'Total:',
    },
  },
  inputManual: 'Manual input',
  systemCalculation: 'System calculation',
  numberOfVolume: 'Number of volume',
  numberOfWeight: 'Number of weight',
  domesticShippingFee: 'Domestic shipping fee',
  towingFee: 'Towing fee',
  otherFee: 'Other fee',
  import: {
    button: 'Import',
    title: 'Import orders',
    description: 'Select an XLSX file (formatted according to the template).',
    noSheet: 'No sheet found in the Excel file',
    readError: 'Failed to read Excel file',
    noData: 'No data to import',
    hasError: 'Import has errors. Please check your data.',
    success: 'Orders imported successfully',
    successWithCounts: 'Orders imported successfully. Created: {created}, Updated: {updated}',
    failed: 'Import failed',
    savedSuccess: 'Saved successfully',
    templateSheetName: 'Order import template',
    templateFileName: 'Order_import_template.xlsx',
    templateSuccess: 'Template file downloaded successfully',
    templateFailed: 'Failed to download template file',
    templateLoading: 'Downloading...',
    templateButton: 'Download template',
  },
  export: {
    button: 'Export',
    fileName: 'Order_list_{date}.xlsx',
    sheetName: 'Order list',
    success: 'Excel file exported successfully',
    failed: 'Failed to export Excel file',
    loading: 'Exporting...',
    columns: {
      code: 'Order code',
      name: 'Order name',
      subCustomerCode: 'Sub customer code',
      numberOfPack: 'Packages',
      customerName: 'Customer',
      fromWarehouseName: 'From warehouse',
      toWarehouseName: 'To warehouse',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
  },
  titles: {
    view: 'Order details',
    show: 'View order',
    edit: 'Edit order',
    create: 'Create order',
    latestOrders: 'Latest orders',
    duplicateOrder: 'Duplicate order',
    deleteOrder: 'Delete order',
    editOrder: 'Edit order',
    addQuick: 'Add quick',
    deleteSelected: 'Delete selected',
    deleting: 'Deleting...',
    selectedCount: '{count} order(s) selected',
  },
  messages: {
    saving: 'Saving...',
    savedSuccess: 'Saved successfully',
    loadOrderError: 'Unable to load order details',
    deleteConfirm: 'Are you sure you want to delete this order? All related shipments will be deleted.',
    deleteSuccess: 'Order deleted',
    deleteError: 'Failed to delete order',
    bulkDeleteConfirm: 'Delete {count} selected order(s)? All related shipments will be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    noData: 'No data',
    totalOrders: 'Total: {total} orders',
  },
}
